<script>
  import { writable } from "svelte/store";
  import { navigate } from "../../router";
  import { getUser } from "../../user.js";
  import { showNotification, showLoader } from "../../dialog.js";
  import { onMount } from "svelte";
  import { load, create, update, loadArticle, BLOG_ABOUT } from "../../articles.js";
  import { HStack, VStack, DStack, Spacer, MediaQuery } from "../layout";
  import { Button, Hamburger, Label } from "../widget";
  import ArticleForm from "./ArticleForm.svelte";
  import Article from "./Article.svelte";
  import Categories from "./Categorie.svelte";
  import Icon from "../widget/Icon.svelte";

  export let wedding;
  export let isOwner;
  export let isEdit;
  export let hasEdit;
  export let category;
  export let article_id;

  //$: console.log(isEdit, hasEdit);

  $: {
    if (article_id !== undefined && category !== undefined) {
      refresh();
    }
  }

  let article = writable(undefined);
  let articles = writable([]);
  let pinned = writable([]);
  let latest = writable([]);
  let aboutArticle = writable(undefined);

  let hamburger = { opened: false, display: true };
  let about = false;
  let isAddArticle = false;
  let created_id = null;
  let published = isEdit ? undefined : true;

  const submit = async (title, category, ranking, content, articleId, published) => {
    try {
      if (articleId) {
        let r = await update(wedding.guid, articleId, title, category, ranking, JSON.stringify(content), published);
        created_id = articleId;
      } else {
        let r = await create(wedding.guid, title, category, ranking, JSON.stringify(content), published);
        created_id = r.data.id;
      }
      isAddArticle = false;
    } catch (e) {
      let msg = e.toString();
      if (msg == "Error: 401 - 22 Access Denied.") {
        msg = "Vous êtes déconnecté - Reconnexion en cours...";
        return showNotification({ text: msg, error: true }).then(() => {
          window.location.reload(true);
        });
      }
      return Promise.reject(e);
    }
  };

  const cancel = () => {
    isAddArticle = false;
  };

  const loadWithCategory = (cat) => {
    category = cat;
    article_id = "";
    created_id = null;
  };

  const refresh_count = () => {};

  const loadArticleFromId = async () => {
    if (article_id !== "") {
      return loadArticle(wedding.guid, article_id)
        .then((r) => {
          article.set(r);
        })
        .catch((e) => {
          article.set(undefined);
          return Promise.reject(e);
        });
    } else {
      article.set(undefined);
      return Promise.resolve(undefined);
    }
  };

  const loadFromCategory = async () => {
    if (article_id === "") {
      return load(wedding.guid, category, published)
        .then((r) => {
          articles.set(r.filter((a)=> a.category != "B" && a.category != "L"));
          isAddArticle = false;
        })
        .catch((e) => {
          articles.set([]);
          return Promise.reject(e);
        });
    } else {
      articles.set([]);
      return Promise.resolve([]);
    }
  };

  const loadPinned = async () => {
    return load(wedding.guid, undefined, published, true, undefined, true)
      .then((r) => {
        pinned.set(r.filter((a)=> a.category != "B" && a.category != "L"));
      })
      .catch((e) => {
        pinned.set([]);
        return Promise.reject(e);
      });
  };

  const loadLatest = async () => {
    return load(wedding.guid, undefined, published, undefined, 5, true)
      .then((r) => {
        latest.set(r.filter((a)=> a.category != "B" && a.category != "L"));
      })
      .catch((e) => {
        latest.set([]);
        return Promise.reject(e);
      });
  };

  const loadAbout = async () => {
    return load(wedding.guid, BLOG_ABOUT)
      .then((r) => {
        aboutArticle.set(r[0]);
      })
      .catch((e) => {
        aboutArticle.set(undefined);
        return Promise.reject(e);
      });
  }

  const refresh = async () => {
    //console.log("refreshing articles", article_id, category);

    await getUser();

    const close = showLoader();

    return Promise.all([loadArticleFromId(), loadFromCategory(), loadPinned(), loadLatest(), loadAbout()])
      .catch((e) => {
        console.log(e);
        let msg = e.toString();
        if (msg == "Error: 401 - 22 Access Denied.") {
          msg = "Vous êtes déconnecté - Reconnexion en cours...";
        }
        return showNotification({ text: msg, error: true }).then(() => {
          window.location.reload(true);
        });
      })
      .finally(() => close());
  };

  let aboutFileinput;
  let aboutArticleId = undefined;
  let aboutArticleImage = undefined;
  aboutArticle.subscribe( (a) => { 
    if (a) { 
      aboutArticleId = a.id
      aboutArticleImage = JSON.parse(a.content)
    } 
  })

  const onAboutFileChange = async (e) => {
    let image = e.target.files[0];
    let reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = e => {
            submit("About", BLOG_ABOUT, 0, {image: e.target.result}, aboutArticleId, true).then(() => {
              loadAbout()
            })
      };
  }

  onMount(() => {
    /* getUser().subscribe((promise) => {
      promise.catch((e) => {
        if (hasEdit) {
          navigate("/");
        }
      });
    }); */
  });
</script>

<article>
  <DStack query="(min-width: 481px)">
    <div class="main">
      <VStack>
        <MediaQuery query="(min-width: 481px)">
          <div>
            <HStack>
              <Categories wedding_guid={wedding.guid} {isEdit} {hasEdit} bind:category />
            </HStack>
          </div>
          <div slot="else">
            <HStack>
              <Hamburger bind:open={hamburger.opened} display={hamburger.display}>
                <Categories
                  wedding_guid={wedding.guid}
                  {isEdit}
                  {hasEdit}
                  bind:category
                  on:action={() => (hamburger.opened = false)} />
              </Hamburger>
              <Spacer />
              <Button action={() => (about = !about)}>
                <Label size="24" icon="question-circle" />
              </Button>
            </HStack>
          </div>
        </MediaQuery>
        <MediaQuery query="(max-width: 480px)">
          {#if about}
            <div class="side">
              <VStack justify="stretch">
                <span class="title">A propos</span>
                <span class="line" />
                <span class="thumbnail">
                  {#if aboutArticleImage}
                    <img src="{aboutArticleImage.image}" alt="Avatar" width="200" height="200" />
                  {:else}
                    <Icon name="user-circle" size="200"></Icon>
                  {/if}
                </span>
                {#if isOwner && isEdit}
                  <HStack justify="center">
                    <Button action={() => aboutFileinput.click() }>
                      <Label size="32" icon="file-upload" />
                    </Button>
                    <input style="display:none" type="file" accept=".jpg, .jpeg, .png" on:change={(e)=>onAboutFileChange(e)} bind:this={aboutFileinput} >
                  </HStack>
                {/if}
                <span class="intro">
                    <p>Blog de {wedding.name}. N’hésitez pas à le visiter régulièrement :-)</p>
                </span>
              </VStack>
            </div>
          {/if}
        </MediaQuery>
        <div class="article">
          {#if isOwner && isEdit}
            {#if isAddArticle}
              <ArticleForm
                {submit}
                {cancel}
                bind:show={isAddArticle}
                category={category}
                on:refresh={refresh} />
            {:else}
              <div class="actions">
                <Button action={() => (isAddArticle = true)}>
                  <!-- <Label text="Ajouter un article" icon="folder-plus" /> -->
                  <button class="primary">
                    <i class="fas fa-folder-plus" />
                    <span>Ajouter un article</span>
                  </button>
                </Button>
              </div>
            {/if}
          {/if}
          {#if $article}
            <Article
              wedding_guid={wedding.guid}
              {isOwner}
              {submit}
              {isEdit}
              article={$article}
              on:refresh={refresh} />
          {:else}
            {#each $articles as a (a.id)}
              <Article
                wedding_guid={wedding.guid}
                {isOwner}
                {submit}
                {isEdit}
                article={a}
                isOpened={created_id == a.id}
                on:refresh={refresh} />
            {/each}
          {/if}
        </div>
      </VStack>
    </div>
    <MediaQuery query="(min-width: 481px)">
      <div class="side">
        <VStack justify="stretch">
          <VStack justify="stretch">
            <span class="title">A propos</span>
            <span class="line" />
            <span class="thumbnail">
                {#if aboutArticleImage}
                    <img src="{aboutArticleImage.image}" alt="Avatar" width="200" height="200" />
                {:else}
                    <Icon name="user-circle" size="200"></Icon>
                {/if}
            </span>
            {#if isOwner && isEdit}
              <HStack justify="center">
                <Button action={() => aboutFileinput.click() }>
                  <Label size="32" icon="file-upload" />
                </Button>
                <input style="display:none" type="file" accept=".jpg, .jpeg, .png" on:change={(e)=>onAboutFileChange(e)} bind:this={aboutFileinput} >
              </HStack>
              {/if}
            <span class="intro">
                <p>Blog de {wedding.name}. N’hésitez pas à le visiter régulièrement :-)</p>
            </span>
          </VStack>
          <VStack justify="stretch" margin="0 0 1em 0">
            <span class="pinned subtitle">A lire</span>
            {#each $pinned as a, i (a.id)}
              <div>
                <Button
                  action={() =>
                    navigate(
                      hasEdit
                        ? `#/wedding/${wedding.guid}/${a.category}/${a.id}?edit=${isEdit}`
                        : `#/wedding/${wedding.guid}/${a.category}/${a.id}`
                    )}>
                  <p>{a.title}</p>
                  {#if a.published != "0"}
                    <span class="published">Publié le {a.published_date}</span>
                  {/if}
                </Button>
              </div>
            {/each}
          </VStack>
          <VStack class="latest" justify="stretch">
            <span class="subtitle">Derniers articles</span>
            {#each $latest as a, i (a.id)}
              <div>
                <Button
                  action={() =>
                    navigate(
                      hasEdit
                        ? `#/wedding/${wedding.guid}/${a.category}/${a.id}?edit=${isEdit}`
                        : `#/wedding/${wedding.guid}/${a.category}/${a.id}`
                    )}>
                  <p>{a.title}</p>
                  {#if a.published != "0"}
                    <span class="published">Publié le {a.published_date}</span>
                  {/if}
                </Button>
              </div>
            {/each}
          </VStack>
        </VStack>
      </div>
    </MediaQuery>
  </DStack>
</article>

<style>
  .side {
    height: 100%;
    width: 100%;
    text-align: center;
  }
  @media screen and (min-width: 481px) {
    .side {
      width: 380px;
    }
  }
  span.subtitle {
    text-align: center;
    background-color: #dbe5e5;
  }

  span.subtitle.pinned {
    background-color: var(--secondary-light-color);
  }

  span.published {
    color: #b8bdbd;
    font-size: small;
  }

  .thumbnail img {
    border-radius: 50%;
    object-fit: cover;
  }
  .line {
    width: 50px;
    margin: 1em auto;
    padding: 0;
    height: 1px;
    background-color: var(--primary-light-color);
  }

  p {
    font-size: smaller;
  }

  .side div p {
    margin-bottom: 0;
  }

  .side span.intro p {
    padding: 1em;
    margin-bottom: 1em;
    border-bottom: 1px solid var(--secondary-light-color);
  }

  .side div:not(:last-child) {
    border-bottom: 1px solid var(--secondary-light-color);
  }

  .main {
    flex: 1 1 auto;
    height: 100%;
    width: 100%;
  }

  .article {
    display: flex;
    flex-direction: column;
    height: 100%;
    flex: 1 1 auto;
    margin-left: 2em;
    margin-right: 2em;
  }
</style>
